<template>
  <section class="home-financing">
    <header class="home-financing__header">
      <DsText as="subtitle7" class="home-financing__title">Todo sobre tu financiamiento</DsText>
      <DsText as="body3" class="home-financing__intro">
        Consulta tus contratos, administra tus seguros, actualiza tu información y accede a
        recursos que te ayudarán a dar seguimiento a tu financiamiento.
      </DsText>
    </header>

    <div class="home-financing__grid">
      <HomeNavigationCard
        v-for="card in cards"
        :key="card.title"
        :icon="card.icon"
        :title="card.title"
        :subtitle="card.subtitle"
        :to="card.to"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from '../../store'
import DsText from '../MaterialApoyo/atoms/DsText.vue'
import HomeNavigationCard from './HomeNavigationCard.vue'

const $store = useStore()

// Íconos exportados del Figma (node 3724:18638).
const iconFinanciamiento = new URL('../../assets/home/ic_financiamiento.svg', import.meta.url).href
const iconSeguros = new URL('../../assets/home/ic_seguros.svg', import.meta.url).href
const iconPerfil = new URL('../../assets/home/ic_perfil.svg', import.meta.url).href
const iconAdjudicaciones = new URL('../../assets/home/ic_adjudicaciones.svg', import.meta.url).href
const iconMateriales = new URL('../../assets/home/ic_materiales.svg', import.meta.url).href
// Titulación no existe en el Figma; se conserva el ícono actual.
const iconTitulacion = new URL('../../assets/Menu/icon_titulacion.svg', import.meta.url).href

const cards = computed(() => {
  const base = [
    {
      icon: iconFinanciamiento,
      title: 'Mi financiamiento',
      subtitle: 'Información de tus contratos',
      to: { name: 'cliente-cliente-financiamiento' }
    },
    {
      // El Figma muestra Seguros como navegación directa (no el dropdown de
      // periodos del home anterior). Los demás seguros siguen accesibles
      // desde el menú de Seguros del header.
      icon: iconSeguros,
      title: 'Seguros',
      subtitle: 'Tus coberturas y tu reporte de siniestro',
      to: { name: 'cliente-cliente-seguro-vida' }
    },
    {
      icon: iconPerfil,
      title: 'Mi perfil',
      subtitle: 'La información de tu cuenta',
      to: { name: 'cliente-cliente-perfil' }
    },
    {
      icon: iconAdjudicaciones,
      title: 'Adjudicaciones',
      subtitle: 'Conoce la lista de clientes que han adjudicado',
      to: { name: 'cliente-cliente-adjudicaciones' }
    },
    {
      icon: iconMateriales,
      title: 'Materiales de apoyo',
      subtitle: 'Inducción al financiamento Hir casa',
      to: { name: 'cliente-cliente-materiales-apoyo' }
    }
  ]

  // Se conserva Titulación del home actual (no aparece en el Figma).
  if ($store.mostrarEscrituracion) {
    base.push({
      icon: iconTitulacion,
      title: 'Titulación',
      subtitle: 'La información de tu proceso de titulación',
      to: { name: 'cliente-cliente-aes' }
    })
  }

  return base
})
</script>

<style scoped>
.home-financing {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.home-financing__header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-financing__title {
  color: var(--ds-purple-900);
  line-height: 24px;
}

.home-financing__intro {
  color: var(--ds-text-primary);
  line-height: 24px;
}

.home-financing__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

@media (max-width: 900px) {
  .home-financing__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .home-financing__grid {
    grid-template-columns: 1fr;
  }
}
</style>
